import { combineReducers, configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import platformMasterSlice from './reducers/platform-master';
import rootSaga from './sagas/root';
import authReducer from './reducers/auth-action';
import componentMasterReducer from './reducers/component-master';
import gatewayMasterReducer from './reducers/gateway-master';
import BuildUseCaseReducer from './reducers/build-usecases';
import UserManagementReducer from './reducers/user-management';
import machineryManagementReducer from './reducers/machinery-management';
import otAssetReducer from './reducers/otAsset';
import servicesReducer from './reducers/services';
import parametersReducer from './reducers/parameter';
import OntgologyMasterReducer from './reducers/ontology-master';
import partManagementReducer from './reducers/part-management';
import factoryManagementReducer from './reducers/factory-management';
import pageActionsReducer from './reducers/page-actions';
import UserRoleReducer from './reducers/user-role';
import UserPasswordReducer from './reducers/profile';
import connectivityDashboardReducer from './reducers/connectivity-dashboard';
import notificationReducer from './reducers/notification';
import settingsReducer from './reducers/settings';
import digitalTwinReducer from './reducers/digital-twin';
import secretManagerReducer from './reducers/secret-manager';
import maintenanceManagementReducer from './reducers/maintenance-management';
import useCaseBuilderReducer from './reducers/usecase-management';

const rootReducer = combineReducers({
  authentication: authReducer.reducer,
  platformServicesMaster: platformMasterSlice.reducer,
  componentMaster: componentMasterReducer.reducer,
  gatewayMaster: gatewayMasterReducer.reducer,
  buildUseCase: BuildUseCaseReducer.reducer,
  userManagement: UserManagementReducer.reducer,
  machineryManagement: machineryManagementReducer.reducer,
  otAsset: otAssetReducer.reducer,
  services: servicesReducer.reducer,
  parameters: parametersReducer.reducer,
  ontologyMaster: OntgologyMasterReducer.reducer,
  partManagement: partManagementReducer.reducer,
  factoryManagement: factoryManagementReducer.reducer,
  pageActions: pageActionsReducer.reducer,
  userRole: UserRoleReducer.reducer,
  profile: UserPasswordReducer.reducer,  
  notification : notificationReducer.reducer,
  settings: settingsReducer.reducer,
  digitalTwin: digitalTwinReducer.reducer,
  connectivityDashboard: connectivityDashboardReducer.reducer,  
  maintenanceManagement:maintenanceManagementReducer.reducer,
  useCaseBuilder: useCaseBuilderReducer.reducer,
  secretsManager : secretManagerReducer.reducer
});

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);
